window.bye = function() {
  $('form').submit(function(){
    $(this).find('button').prop('disabled', true);
    $(this).find('button').html('<img src="spin.gif" style="height:25px" />');
  });
}
